import moment from "moment";
import {getAllInvitations, getConnectedAccounts} from "../api/creatorinvitations/creatorinvitations";
import {getTenantInfo} from "../api/tenantInformation/tenantInformation";

import {
    AccountStatus,
    CREATOR_COLUMNS,
    creatorModuleSpecificTenantIDs,
    DATE_TIME_FORMAT,
    envBaseURLMapping,
    products,
    sandboxProducts,
    statusContentMapping,
    TabValues,
    WORKPLATFROMIDMAPPING,
    WORKPLATFROMPRODUCTMAPPING,
} from "../constants/constants";
import {CreatorDatePicker, Icons, PlatformFilter, Tag} from "../components";
import './util.scss';
import React from "react";
import {Tooltip} from "@mui/material";
import {LogosWithStatus} from "./iconHelper";
import {checkRemoved, getUserName} from "./profileHelpers";

export const getExpiryTime = (date) => {
    // const date = moment("2022-08-25T21:15:11.129994");

    const currentDate = moment.utc(new Date()).format();
    const expiryDate = moment.utc(date).format();
    const duration = moment.duration(moment(expiryDate).diff(moment(currentDate)));
    // const duration = moment.duration(date.diff(currentDate));
    const pendingMinutes = duration.asMinutes();
    const pendingHours = duration.asHours();
    const pendingDays = Math.round(pendingHours / 24);

    if (pendingDays > 0) return pendingDays + `${pendingDays === 1 ? " day" : " days"}`;
    else {
        const roundedPendingHours = Math.round(pendingHours);
        if (roundedPendingHours > 0) return roundedPendingHours + `${roundedPendingHours === 1 ? " hour" : " hours"}`;
        else {
            const roundedPendingMinutes = Math.round(pendingMinutes);
            return roundedPendingMinutes + `${roundedPendingMinutes === 1 ? " minute" : " minutes"}`;
        }
    }
};

export const getClientIDAndSecret = async (environment) => {
    let tenantInfo = await getTenantInfo(environment);
    let clientSecret;
    const clientId = tenantInfo[0]?.apps[0].id;
    const clientSecrets = tenantInfo[0]?.apps[0].credentials;
    clientSecret = clientSecrets[0]?.client_secret;
    return {clientId, clientSecret};
};

export function getSdkEnv(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
}

export const getAuthKey = (CLIENT_ID, CLIENT_SECRET) => {
    const AUTH_KEY = window.btoa(CLIENT_ID + ":" + CLIENT_SECRET);
    if (!JSON.parse(localStorage.getItem("SDK_USER_CREDS"))) {
        const SDK_USER_CREDS = {};
        SDK_USER_CREDS.authKey = AUTH_KEY;
        localStorage.setItem("SDK_USER_CREDS", JSON.stringify(SDK_USER_CREDS));
    }
    if (localStorage.getItem("SDK_USER_CREDS") === "{}") {
        localStorage.removeItem("SDK_USER_CREDS");
        const SDK_USER_CREDS = {};
        SDK_USER_CREDS.authKey = AUTH_KEY;
        localStorage.setItem("SDK_USER_CREDS", JSON.stringify(SDK_USER_CREDS));
    } else {
        let user_sdk_creds = JSON.parse(localStorage.getItem("SDK_USER_CREDS"));
        if (user_sdk_creds) {
            user_sdk_creds.authKey = AUTH_KEY;
        }
    }
    return AUTH_KEY;
};

export const flattenObj = (ob) => {
    let result = {};
    for (const i in ob) {
        if (typeof ob[i] === "object" && !Array.isArray(ob[i])) {
            const temp = flattenObj(ob[i]);
            for (const j in temp) {
                result[i + "." + j] = temp[j];
            }
        } else {
            result[i] = ob[i];
        }
    }
    return result;
};

export const createWorkplatformMapping = (obj) => {
    const mappedObj = {};
    Object.keys(obj).map((item) => {
        if (item in WORKPLATFROMPRODUCTMAPPING) mappedObj[WORKPLATFROMPRODUCTMAPPING[item]] = obj[item];
    });
    return mappedObj;
};

export const getProductsList = (environment) => {
    if (environment === "sandbox") {
        localStorage.setItem("PHYLLO_DD_PRDS", JSON.stringify(sandboxProducts));
    } else localStorage.setItem("PHYLLO_DD_PRDS", JSON.stringify(products));
};

export const runPollingLogicAPIInLocal = async (tenantInfo, environment) => {
    if (environment === "staging") {
        var clientId = tenantInfo[0]?.apps[0].id;
        let clientSecrets = tenantInfo[0]?.apps[0].credentials;
        var clientSecret = clientSecrets[0]?.client_secret;
    } else if (environment === "production") {
        var clientId = "3e3e6361-dda5-4d07-b12e-90f63551b7ff";
        var clientSecret = "b5a77e38-16ea-4d7c-b121-b848599caf22";
    } else {
        var clientId = "0b8e3c34-9c0b-414d-8282-7f6e20d2132f";
        var clientSecret = "6321aad7-9eb3-46c6-85f2-a094262a39a6";
    }
    return {clientId, clientSecret};
};

export const runAllEnvsAPIsInLocal = async (environment) => {
    if (environment === "staging") {
        var {clientId, clientSecret} = await getClientIDAndSecret(environment);
    } else if (environment === "production") {
        var clientId = "3e3e6361-dda5-4d07-b12e-90f63551b7ff";
        var clientSecret = "b5a77e38-16ea-4d7c-b121-b848599caf22";
    } else {
        var clientId = "0b8e3c34-9c0b-414d-8282-7f6e20d2132f";
        var clientSecret = "6321aad7-9eb3-46c6-85f2-a094262a39a6";
    }
    return {clientId, clientSecret};
};

export const getEnvBaseURL = (environment) => {
    return envBaseURLMapping[environment];
};

export const getTabSelectedAPI = async (tab, offset, searchValue, sortDesc, environment, work_platform_ids, account_status, dateRange) => {
    if (tab === TabValues.all) {
        let allInvitationsResponse = await getAllInvitations(offset, searchValue, sortDesc, environment, work_platform_ids, account_status, dateRange);
        return allInvitationsResponse;
    } else if (tab === TabValues.connectedAccounts) {
        let allConnectedAccountsResponse = await getConnectedAccounts(offset, searchValue, sortDesc, environment, work_platform_ids, account_status, dateRange);
        return allConnectedAccountsResponse;
    }
};

function getTooltipText(acc) {
    const {work_platform_id, platform_username, platform_profile_name, status} = acc;
    const userName = getUserName({
        work_platform: {id: work_platform_id},
        platform_username,
        platform_profile_name
    });
    const platformName = WORKPLATFROMIDMAPPING[work_platform_id].platformName;
    const statusLabel = checkRemoved(acc) ? AccountStatus.REMOVED.label : AccountStatus[status]?.label;
    const tooltipText = (userName && userName.length > 0) ? `${platformName} - ${userName} - ${statusLabel}` : `${platformName} - ${statusLabel}`;
    return <div>{tooltipText}</div>;
}

function getIcon({work_platform_id, status}) {
    const platformName = WORKPLATFROMIDMAPPING[work_platform_id].platformName;
    const platformComponent = LogosWithStatus[platformName.toLowerCase()];
    const Component = platformComponent ? platformComponent[status.toLowerCase()] : null;
    if (!Component) {
        return null;
    }
    return <Component/>;
}

function getFilterIcon(isFiltered) {
    return isFiltered ?
        <i className={'ri-filter-3-line filter-active'}></i> :
        <i className={'ri-filter-3-line filter-default'}></i>;
}

function getPlatformColumn(dataIndex, displayString, platformFilterConfig, otherProps = {}) {
    const {
        appliedPlatforms,
        appliedPlatformStatuses,
        isPlatformsFilterVisible,
        setPlatformsFilterVisible
    } = platformFilterConfig;
    const {width} = otherProps;

    function render(accounts) {
        if (!accounts || accounts.length === 0) {
            return null;
        }
        const tooltipText = accounts.map(getTooltipText);
        return (
            <Tooltip title={tooltipText} placement={'right-start'}>
                <div className={'div-platform-icons'}>
                    {accounts.slice(0, 4).map(getIcon)}
                    {(accounts.length - 4 > 0) ? <div className={'circle'}>{'+'}{accounts.length - 4}</div> : null}
                </div>
            </Tooltip>
        );
    }

    return {
        dataIndex: dataIndex,
        filterDropdown: <PlatformFilter platformFilterConfig={platformFilterConfig}/>,
        filterDropdownOpen: isPlatformsFilterVisible,
        filterIcon: () => getFilterIcon(appliedPlatforms?.length > 0 || appliedPlatformStatuses?.length > 0),
        filterMultiple: true,
        id: dataIndex,
        key: dataIndex,
        onFilterDropdownOpenChange: setPlatformsFilterVisible,
        render,
        title: displayString,
        width: width || '13%',
    };
}

function getDateColumn(dataIndex, displayString, sortConfig, dateFilterConfig, otherProps = {}) {
    const {
        dateRange,
        isDatePickerVisible,
        setDatePickerVisible
    } = dateFilterConfig;
    const {sortDesc, setSortDesc} = sortConfig;
    const {width} = otherProps;

    return {
        dataIndex,
        filterDropdown: <CreatorDatePicker dateFilterConfig={dateFilterConfig}/>,
        filterDropdownOpen: isDatePickerVisible,
        filterIcon: () => getFilterIcon(dateRange?.fromDate || dateRange?.toDate),
        key: dataIndex,
        onFilterDropdownOpenChange: setDatePickerVisible,
        onHeaderCell: (column) => {
            return {
                onClick: () => {
                    setSortDesc((sortDesc) => {
                        return !sortDesc;
                    });
                },
            };
        },
        render: (date) => moment(date).format(DATE_TIME_FORMAT),
        title: () => {
            return (
                <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
                    {displayString}
                    {sortDesc ? (
                        <Icons.down_arrow_icon alt="down_arrow_icon"/>
                    ) : (
                        <Icons.down_arrow_icon alt="down_arrow_icon" style={{transform: "rotateZ(180deg)"}}/>
                    )}
                </div>
            );
        },
        width: width || '15%',
    };
}

export const getTabSelectedTableColumns = (tab, sortDesc, setSortDesc, platformFilterConfig, dateFilterConfig) => {
    const allInvitedTableColumns = [
        {
            title: CREATOR_COLUMNS.NAME,
            dataIndex: "name",
            width: "15%",
            id: "name",
            ellipsis: true,
        },
        {
            title: CREATOR_COLUMNS.EMAIL,
            dataIndex: "email",
            width: "20%",
            id: "email",
            ellipsis: true,
        },
        {
            title: CREATOR_COLUMNS.STATUS,
            key: "status",
            id: "status",
            dataIndex: "status",
            width: "8%",
            render: (_, {status}) => (
                <>
                    {status.map((tag) => {
                        return (
                            <Tag color={statusContentMapping[tag]?.color} key={tag} height="28px" width="110px" fontSize="12px">
                                {statusContentMapping[tag]?.label}
                            </Tag>
                        );
                    })}
                </>
            ),
        },
        getPlatformColumn('accounts', CREATOR_COLUMNS.PLATFORM, platformFilterConfig),
        getDateColumn('invited_on', CREATOR_COLUMNS.INVITED_ON, {sortDesc, setSortDesc}, dateFilterConfig),
        {
            title: CREATOR_COLUMNS.ACTIONS,
            dataIndex: "buttons",
            width: "5%",
            id: "buttons",
        },
    ];

    const connectedAccountsTableColumns = [
        {
            title: CREATOR_COLUMNS.NAME,
            dataIndex: "name",
            width: "15%",
            id: "name",
            ellipsis: true,
        },
        {
            title: CREATOR_COLUMNS.EMAIL,
            dataIndex: "email",
            width: "20%",
            id: "email",
            ellipsis: true,
        },
        {
            title: CREATOR_COLUMNS.USERNAME,
            dataIndex: "username",
            width: "15%",
            id: "username",
            ellipsis: true,
        },
        getPlatformColumn('accounts', CREATOR_COLUMNS.PLATFORM, platformFilterConfig, {width: '5%'}),
        getDateColumn('connected_on', CREATOR_COLUMNS.CONNECTED_ON, {sortDesc, setSortDesc}, dateFilterConfig),
        {
            title: CREATOR_COLUMNS.ACTIONS,
            dataIndex: "buttons",
            width: "5%",
        }
    ];


    const tableColumnsMappingWithTabSelected = {
        All: allInvitedTableColumns,
        "Connected accounts": connectedAccountsTableColumns,
    };

    return tableColumnsMappingWithTabSelected[tab];
};

export const isCreatorModuleSpecificTenant = (tenantId) => {
    if (creatorModuleSpecificTenantIDs.includes(tenantId)) return true;
    return false;
};
